import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=4a7521af&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=js"
export * from "./HelpCenter.vue?vue&type=script&lang=js"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=4a7521af&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7521af",
  null
  
)

export default component.exports